import {Block, Icon} from "../components";
import React from "react";
import {Button, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import Table from "../tables/Table";
import {TableSearchRow} from "../tables/TableSearch";

export function DataProductList({data, ...props}) {

  if (data.length > 0) {
    return (
      <>
        <TableSearchRow {...props.tableSearchProps}/>
        <Block>
          <Table data={data} columns={props.columns} onRowClick={props.onRowClick} {...props.tableProps} />
        </Block>
      </>
    )
  } else {
    return <EmptyBlock onClick={props.onAdd} newButtonContent={props.newButtonContent}/>
  }
}

function EmptyBlock(props) {
  const { t } = useTranslation();

  return (
    <>
      <Row className="justify-content-md-center">
        <div><Icon icon="empty" size="10x" variant="secondary"/></div>
      </Row>
      <Row className="justify-content-md-center">
        <div style={{marginTop: '20px'}}>{t("dataVendor.emptySection")}</div>
      </Row>
      <Row className="justify-content-md-center">
        <Button style={{marginTop: '20px'}} variant={"primary"} onClick={props.onClick}>{props.newButtonContent}</Button>
      </Row>
    </>
  )

}
